import { inject, Injectable } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import {
	CommonsPreferenceDataSource,
	Preference,
	PreferenceApiService,
} from "@jack-sparrow-libraries/angular-business-commons";
import { SoignantMapperService } from "@featuresAY/idel-web-ay/service/mappers/soignant-mapper.service";
import { AuthenticatedSoignantService } from "../auth/soignant/authenticated-soignant-service";
import { toObservable } from "@angular/core/rxjs-interop";
import { filter } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class PreferencesService implements CommonsPreferenceDataSource {
	private readonly preferencesApiService = inject(PreferenceApiService);
	private readonly authenticatedSoignantService = inject(AuthenticatedSoignantService);

	getPreferences(): Observable<Preference[]> {
		return toObservable(this.authenticatedSoignantService.$connectedSoignant()).pipe(
			filter((s) => !!s),
			switchMap((s) => this.preferencesApiService.loadAll(SoignantMapperService.toDto(s))),
		);
	}

	setPreference(preference: Preference): Observable<Preference[]> {
		return this.preferencesApiService.update(preference);
	}
}
